import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav',
  template: `
   <nav class="navbar navbar-dark bg-dark">
     <a class="navbar-brand" href="">
      <span style="color: green">Covid</span> -19 <small style="font-size: 0.5em; color: red">situazione Italia</small>
     </a>
     <a class="nav-link" href="#">
       <i class="fa fa-calendar" aria-hidden="true" style="margin-right: 8px"></i>
       <span style="color: rgb(255, 170, 0);">{{date | date: 'dd-MM-yyyy'}}</span>
     </a>
   </nav>
  `,
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
  // oggetto per la data
  date: Date = new Date();
  constructor() { }

  ngOnInit(): void {
  }

}
